import fundaNowClient from '@/client/fundaNowClient'
import qs from 'query-string'

export default {
  getTerms() {
    return fundaNowClient.call({
      url: '/terms/',
      method: 'GET',
    })
  },
  getTerm(code, param) {
    return fundaNowClient.call({
      url: `/terms/${code}/?${qs.stringify(param, {
        skipNull: true,
        skipEmptyString: true
      })}`,
      method: 'GET',
    })
  },
  agreeTerms(terms) {
    return fundaNowClient.call({
      url: '/agreements/',
      method: 'POST',
      data: terms
    })
  },
}
